"use strict";

/**
 * The price adjecements component handler
 */

const $ = require("jquery");
const axios = require("axios");
const formStatus = require("./../booking-form-status/booking-form-status");
const statusClass = "js-price-adjustments-form-status";

function getUploadUrl() {
  const route = $(".js-price-adjustments-form").data("url");
  const url = route;
  return url;
}

function getCreateUrl() {
  const route = $(".js-price-adjustments-form").data("url");
  const url = `${route}/create`;
  return url;
}

function getUpdateUrl(id) {
  const route = $(".js-price-adjustments-form").data("url");
  const url = `${route}/${id}`;
  return url;
}

function getDeleteUrl(id) {
  const route = $(".js-price-adjustments-form").data("url");
  const url = `${route}/${id}`;
  return url;
}

/**
 * Disables the form elements.
 */
function disableInteractions() {
  $(".js-price-adjustments-form")
    .find("button")
    .attr("disabled", true);

  $(".js-price-adjustments-form")
    .find("select")
    .attr("disabled", true);

  $(".js-price-adjustments-form")
    .find("input")
    .attr("disabled", true);

  $(".js-price-adjustments-table")
    .find("button")
    .attr("disabled", true);

  $(".js-price-adjustments-form")
    .find("button")
    .removeClass("button--orange");

  $(".js-price-adjustments-form")
    .find("button")
    .addClass("button--grey");

  // $(".js-price-adjustments-table")
  //   .find("button")
  //   .removeClass("button--red");

  // $(".js-price-adjustments-table")
  //   .find("button")
  //   .removeClass("button--blue");

  // $(".js-price-adjustments-table")
  //   .find("button")
  //   .removeClass("button--orange");

  $(".js-price-adjustments-table")
    .find("button")
    .addClass("button--grey");
}

/**
 * Restore the status of the form elements (to not disabled).
 */
function enableInteractions() {
  $(".js-price-adjustments-form")
    .find("button")
    .attr("disabled", false);

  $(".js-price-adjustments-form")
    .find("select")
    .attr("disabled", false);

  $(".js-price-adjustments-form")
    .find("input")
    .attr("disabled", false);

  $(".js-price-adjustments-table")
    .find("button")
    .attr("disabled", false);

  $(".js-price-adjustments-form")
    .find("button")
    .removeClass("button--grey");

  $(".js-price-adjustments-form")
    .find("button")
    .addClass("button--orange");

  $(".js-price-adjustments-table")
    .find("button")
    .removeClass("button--grey");

  // $(".js-price-adjustments-table")
  //   .find("button[data-action=save]")
  //   .addClass("button--orange");

  // $(".js-price-adjustments-table")
  //   .find("button[data-action=edit]")
  //   .addClass("button--blue");

  // $(".js-price-adjustments-table")
  //   .find("button[data-action=delete]")
  //   .addClass("button--red");
}

/**
 *
 * Sets a row to edit mode.
 *
 * @param {object} row the html-element object for the row to be edited.
 */
function toEditMode(row) {
  const rawValue = $(row)
    .find("div[data-mode=view] span[data-name=value-bundle]")
    .text()
    .trim();

  const sign = rawValue.indexOf("+") >= 0 ? "+" : "-";
  const value = rawValue
    .replace("-", "")
    .replace("+", "")
    .replace("%", "")
    .replace("€", "");
  const type = rawValue.indexOf("%") >= 0 ? "relative" : "absolute";

  $(row)
    .find("div[data-mode=view]")
    .attr("hidden", true);

  $(row)
    .find("div[data-mode=view]")
    .removeClass("d-flex");

  $(row)
    .find("div[data-mode=edit]")
    .attr("hidden", false);
  $(row)
    .find("div[data-mode=edit] .form-control")
    .attr("disabled", false);
  $(row)
    .find("div[data-mode=edit] button")
    .attr("disabled", false);

  $(row)
    .find("div[data-mode=edit]")
    .addClass("d-flex");

  $(row)
    .find("div[data-mode=edit] .form-control[name=sign]")
    .val(sign);
  $(row)
    .find("div[data-mode=edit] .form-control[name=value]")
    .val(value);
  $(row)
    .find("div[data-mode=edit] .form-control[name=type]")
    .val(type);

  $(row)
    .find("button[data-action=delete]")
    .tooltip("hide");
  $(row)
    .find("button[data-action=edit]")
    .tooltip("hide");

  $(row).addClass("price-adjustments__row--edit-state");
}

/**
 *
 * Sets a row to view mode.
 *
 * @param {object} row the html-element object for the row to be restored.
 */
function toViewMode(row) {
  $(row)
    .find("div[data-mode=view]")
    .attr("hidden", false);

  $(row)
    .find("div[data-mode=view]")
    .addClass("d-flex");

  $(row)
    .find("div[data-mode=edit]")
    .attr("hidden", true);
  $(row)
    .find("div[data-mode=edit] .form-control")
    .attr("disabled", true);
  $(row)
    .find("div[data-mode=edit] button")
    .attr("disabled", true);

  $(row)
    .find("div[data-mode=edit]")
    .removeClass("d-flex");

  $(row)
    .find("button[data-action=cancel]")
    .tooltip("hide");
  $(row)
    .find("button[data-action=save]")
    .tooltip("hide");

  $(row).removeClass("price-adjustments__row--edit-state");
}

/**
 *
 * @param {object} data The data to display in the format the the end-point send
 *                       it.
 * @param {string} eventTypeText  The event type label
 */
function addRowToTable(data, eventTypeText) {
  const table = $(".js-price-adjustments-table");
  const id = data.priceAdjustment.id;
  const eventType = eventTypeText;
  const sign = data.priceAdjustment.value < 0 ? "-" : "+";
  const type = data.priceAdjustment.type === "relative" ? "%" : "€";
  const value = Math.abs(data.priceAdjustment.value);
  const label = sign + " " + value + type;
  const priceAdjustmentId = data.priceAdjustment.event_type_id;
  const newHTML = getTableRow(id, priceAdjustmentId, eventType, label);

  $(table)
    .find("tbody")
    .append(newHTML);
  const parsedRow = $(table).find("tr[data-id=" + id + "]");

  const saveButton = $(parsedRow).find("button[data-action=save]");
  const editButton = $(parsedRow).find("button[data-action=edit]");
  const deleteButton = $(parsedRow).find("button[data-action=delete]");
  const cancelButton = $(parsedRow).find("button[data-action=cancel]");

  $(saveButton).on("click", function() {
    updateRow(parsedRow);
  });

  $(editButton).on("click", function() {
    toEditMode(parsedRow);
  });

  $(deleteButton).on("click", function() {
    deleteRow(parsedRow);
  });

  $(cancelButton).on("click", function() {
    toViewMode(parsedRow);
  });

  const newSignSelect = $(".js-price-adjustments-form__sign").clone();
  $(newSignSelect).removeClass("js-price-adjustments-form__sign");
  $(newSignSelect).attr("id", "");
  $(newSignSelect).attr("name", "sign");
  $(newSignSelect).attr("data-toggle", "popover");
  $(newSignSelect).attr("data-placement", "top");
  $(newSignSelect).attr("data-trigger", "focus");

  const newValueInput = $(".js-price-adjustments-form__price").clone();
  $(newValueInput).removeClass("js-price-adjustments-form__price");
  $(newValueInput).attr("id", "");
  $(newValueInput).attr("name", "value");
  $(newValueInput).val("");
  $(newValueInput).attr("data-toggle", "popover");
  $(newValueInput).attr("data-placement", "top");
  $(newValueInput).attr("data-trigger", "focus");

  const newTypeSelect = $(".js-price-adjustments-form__symbol").clone();
  $(newTypeSelect).removeClass("js-price-adjustments-form__symbol");
  $(newTypeSelect).attr("id", "");
  $(newTypeSelect).attr("name", "type");
  $(newTypeSelect).attr("data-toggle", "popover");
  $(newTypeSelect).attr("data-placement", "top");
  $(newTypeSelect).attr("data-trigger", "focus");

  const newTypeError = $(".js-price-adjustments__error").clone();
  $(newTypeError).text("");

  $(parsedRow)
    .find(".js-price-adjustments-edit")
    .append(newSignSelect);
  $(parsedRow)
    .find(".js-price-adjustments-edit")
    .append(newValueInput);
  $(parsedRow)
    .find(".js-price-adjustments-edit")
    .append(newTypeSelect);
  $(parsedRow)
    .find(".js-price-adjustments-edit")
    .append(newTypeError);
}

/**
 *
 * Handles a sucessful upload.
 *
 * @param {object} data the data that was received from the end-point.
 * @param {string} eventTypeText The event type label
 */
function onUploadSuccess(data, eventTypeText) {
  addRowToTable(data, eventTypeText);
  formStatus.showSuccess(statusClass, data.success);
  handlePriceAdjustmentTableVisibility();
}

/**
 *
 * @param {object} data the data that was received from the end-point.
 * @param {object} row
 */
function onUpdateSuccess(data, row) {
  formStatus.showSuccess(statusClass, data.success);
  toViewMode(row);

  const type = data.priceAdjustment.type === "absolute" ? "€" : "%";
  const value =
    data.priceAdjustment.value > 0
      ? "+" + data.priceAdjustment.value
      : data.priceAdjustment.value;

  const newValue = value + "" + type;

  $(row)
    .find("span[data-name=value-bundle]")
    .text(newValue);

  handlePriceAdjustmentTableVisibility();
}

/**
 *
 * Handles the upload error.
 *
 * @param {object} err the error object that was received from the end-point.
 */
function onUploadError(err) {
  let errors = err.response.data.errors;
  for (let attribute in errors) {
    let errorsForAttribute = errors[attribute];
    let errorMessage = errorsForAttribute[0];
    formStatus.showError(statusClass, errorMessage);
  }

  handlePriceAdjustmentTableVisibility();
}

/**
 *
 * @param {object} row the html-element object of the row the
 * @param {string} message the message to be shown
 */
function onDeleteSuccess(row, message) {
  formStatus.showSuccess(statusClass, message);
  $(row).remove();
  handlePriceAdjustmentTableVisibility();
}

function onDeleteError(err) {
  formStatus.showError(statusClass, err.response.data.message);
  handlePriceAdjustmentTableVisibility();
}

/**
 *
 * @param {string} url The url of the end point.
 * @param {object} formData the FormData object
 * @param {string} method  the http action GET|POST|PUT|DELETE
 * @param {object} row the html-element
 * @param {string} eventTypeText
 * @param {string} source (form|row) if is called from row or form the form
 */
function makeRequest(url, formData, method, row, eventTypeText, source) {
  disableInteractions();

  $(row)
    .find(".form-control[name=value]")
    .attr("data-content", "")
    .removeClass("is-invalid")
    .popover("dispose");

  $(row)
    .find(".form-control[name=sign]")
    .attr("data-content", "")
    .removeClass("is-invalid")
    .popover("dispose");

  $(row)
    .find(".form-control[name=type]")
    .attr("data-content", "")
    .removeClass("is-invalid")
    .popover("dispose");

  const headers = {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    cache: false
  };

  axios
    .post(url, formData, headers)
    .then(function(result) {
      readThePriceAdjustments(function() {
        enableInteractions();
        $(".js-loader").removeClass("loader--active");
        if (method == "DELETE") {
          onDeleteSuccess(row, result.data.success);
        } else if (method == "PUT") {
          onUpdateSuccess(result.data, row);
        } else {
          onUploadSuccess(result.data, eventTypeText);
        }
      });
    })
    .catch(function(err) {
      if (err.response.data.errors) {
        let errors = err.response.data.errors;
        for (let attribute in errors) {
          let errorsForAttribute = errors[attribute];
          let errorMessage = errorsForAttribute[0];

          if (source === "form") {
            if (attribute === "event_type_id") {
              $(".js-price-adjustments-form__event-type").addClass(
                "is-invalid"
              );
              $(".js-price-adjustments-form__event-type + small").addClass(
                "is-invalid"
              );
              $(".js-price-adjustments-form__event-type + small").text(
                errorMessage
              );
            } else if (attribute === "value") {
              $(".js-price-adjustments-form__price").addClass("is-invalid");
              $(".js-price-adjustments-form__price + small").addClass(
                "is-invalid"
              );
              $(".js-price-adjustments-form__price + small").text(errorMessage);
            }
          } else if (source === "row") {
            if (attribute === "value") {
              $(row)
                .find(".form-control[name=value]")
                .attr("data-content", errorMessage)
                .addClass("is-invalid")
                .popover();
            } else if (attribute === "sign") {
              $(row)
                .find(".form-control[name=sign]")
                .attr("data-content", errorMessage)
                .addClass("is-invalid")
                .popover();
            } else if (attribute === "type") {
              $(row)
                .find(".form-control[name=type]")
                .attr("data-content", errorMessage)
                .addClass("is-invalid")
                .popover();
            }
          }
        }
      }

      enableInteractions();
      $(".js-price-loader").removeClass("loader--active");
      $(".js-loader").removeClass("loader--active");
      if (method == "DELETE") {
        onDeleteError(err);
      } else {
        onUploadError(err);
      }
    });
}

/**
 *
 * POSTs a new item to the endpoint.
 *
 */
function submit() {
  formStatus.clearStatus(statusClass);
  $(".js-price-loader").addClass("loader--active");
  const productId = $(".js-price-adjustments-form").attr("data-product");
  const url = getUploadUrl();
  const eventType = $(".js-price-adjustments-form__event-type").val();
  const sign = $(".js-price-adjustments-form__sign").val();
  const value = $(".js-price-adjustments-form__price").val();
  const type = $(".js-price-adjustments-form__symbol").val();
  const token = $(
    $(".js-price-adjustments-form  input[name=_token]").get(0)
  ).val();

  const selectedIndex = $(".js-price-adjustments-form__event-type").get(0)
    .selectedIndex;
  const selectedOption = $(".js-price-adjustments-form__event-type").get(0)
    .options[selectedIndex];
  const eventTypeText = selectedOption.text;

  const formData = new FormData();
  formData.append("product_id", productId);
  formData.append("event_type_id", eventType);
  formData.append("sign", sign);
  formData.append("value", value);
  formData.append("type", type);
  formData.append("_method", "POST");
  formData.append("_token", token);

  $(".js-price-adjustments-form__event-type").removeClass("is-invalid");
  $(".js-price-adjustments-form__event-type + small").removeClass("is-invalid");
  $(".js-price-adjustments-form__event-type + small").text("");
  $(".js-price-adjustments-form__price").removeClass("is-invalid");
  $(".js-price-adjustments-form__price + small").removeClass("is-invalid");
  $(".js-price-adjustments-form__price + small").text("");

  const method = "POST";
  makeRequest(url, formData, method, null, eventTypeText, "form");
}

/**
 *
 * PUTs the new state of the price-adjustment to the end-point.
 *
 * @param {object} row The html-element object of the row to be updated
 */
function updateRow(row) {
  formStatus.clearStatus(statusClass);

  $(row)
    .find(".js-loader")
    .addClass("loader--active");

  const productId = $(".js-price-adjustments-form").attr("data-product");

  const token = $(
    $(".js-price-adjustments-form  input[name=_token]").get(0)
  ).val();

  const eventType = $(row)
    .find("span[data-name=event-type]")
    .attr("data-event-type");

  const sign = $(row)
    .find("select[name=sign]")
    .val();
  const value = $(row)
    .find("input[name=value]")
    .val();
  const type = $(row)
    .find("select[name=type]")
    .val();
  const method = "PUT";
  const id = $(row).attr("data-id");
  const url = getUpdateUrl(id);

  const formData = new FormData();
  formData.append("product_id", productId);
  formData.append("sign", sign);
  formData.append("value", value);
  formData.append("type", type);
  formData.append("_method", method);
  formData.append("event_type_id", eventType);
  formData.append("_token", token);

  if ($(row).find(".js-price-adjustments-row-value")) {
    $(row)
      .find(".js-price-adjustments-row-value")
      .removeClass("is-invalid");
  }

  if ($(row).find(".js-price-adjustments__error")) {
    $(row)
      .find(".js-price-adjustments__error")
      .removeClass("is-invalid");
  }

  if ($(row).find(".js-price-adjustments__error")) {
    $(row)
      .find(".js-price-adjustments__error")
      .text("");
  }

  makeRequest(url, formData, method, row, null, "row");
}

/**
 * DELETEs an item given the row it is placed.
 *
 * @param {object} row the row of the table to be removed.
 *  The row must have a data-id attribute.
 */
function deleteRow(row) {
  formStatus.clearStatus(statusClass);
  $(row)
    .find("[data-toggle=tooltip]")
    .tooltip("hide");

  const id = $(row).attr("data-id");
  $(row)
    .find(".js-loader")
    .addClass("loader--active");
  const url = getDeleteUrl(id);
  const method = "DELETE";
  const token = $(
    $(row)
      .find("input[name=_token]")
      .get(0)
  ).attr("value");

  const formData = new FormData();
  formData.append("_method", method);
  formData.append("token", token);

  makeRequest(url, formData, method, row, "row");
}

/**
 * GETs the prices from the end point using the makeRequest function.
 */
function readThePriceAdjustments(resolve) {
  const url = getCreateUrl();
  axios(url, {
    headers: {
      Accept: "application/json"
    }
  })
    .then(function(result) {
      if (result.headers["content-type"] !== "application/json") {
        $(".js-price-adjustments-form").attr("hidden", true);
      } else {
        $(".js-price-adjustments-form").attr("hidden", false);
        $(".js-price-adjustments-form__event-type").html("");

        const items = Object.values(result.data.eventTypes);

        for (let item of items) {
          $(".js-price-adjustments-form__event-type").append(
            "<option value=" + item.id + ">" + item.name + "</option>"
          );
        }

        $(".js-price-adjustments-form").attr("hidden", items.length === 0);
      }
      resolve && resolve();
    })
    .catch(function(err) {});
}

/**
 * Toggles the price adjustments talbe visibility
 */
function handlePriceAdjustmentTableVisibility() {
  const hasRows = $(".js-price-adjustments-table tr").length > 1;
  $(".js-price-adjustments-table").attr("hidden", !hasRows);
}

/**
 * initializes the component
 */
function onLoad() {
  $(".js-price-adjustments-form")
    .find("button")
    .on("click", function() {
      submit();
    });

  $(".js-price-adjustments-table tr").each(function(i, priceRow) {
    $(priceRow)
      .find("button[data-action=delete]")
      .on("click", function() {
        deleteRow(priceRow);
      });

    $(priceRow)
      .find("button[data-action=edit]")
      .on("click", function() {
        toEditMode(priceRow);
      });

    $(priceRow)
      .find("button[data-action=cancel]")
      .on("click", function() {
        toViewMode(priceRow);
      });

    $(priceRow)
      .find("button[data-action=save]")
      .on("click", function() {
        updateRow(priceRow);
      });
  });

  $(".section-content--prices").each(function() {
    readThePriceAdjustments();
  });

  handlePriceAdjustmentTableVisibility();
}

function getTableRow(id, eventTypeId, label, value) {
  const table = $(".js-price-adjustments-table");

  const saveLabel = table.attr("data-label-save");
  const editLabel = table.attr("data-label-edit");
  const cancelLabel = table.attr("data-label-cancel");
  const deleteLabel = table.attr("data-label-delete");

  return `
  <tr data-id="${id}" data-event="true" price-adjustments__row>
      <td  colspan="2">
        <span data-name="event-type"  data-event-type="${eventTypeId}">
          ${label}
        </span>
      </td>
      <td  colspan="3">
        <div data-mode="view"  class="d-flex  justify-content-center justify-content-sm-start">
          <span data-name="value-bundle">
            ${value}
          </span>
        </div>
        <div data-mode="edit" class="js-price-adjustments-edit form-group price-adjustments__form-wrapper" hidden>

        </div>
      </td>
      <td class="pl-0" colspan="1">
        <div data-mode="view"  class="d-flex">
          <button class="button price-adjustments__button price-adjustments__button--edit" type="button"
            data-action="edit" title="${editLabel}" data-toggle="tooltip"  data-placement="top"
          >
            <i class="fas fa-pencil-alt"></i>
          </button>


          <button class="button price-adjustments__button price-adjustments__button--delete" type="button"
            data-action="delete" title=" ${deleteLabel}"  data-toggle="tooltip"  data-placement="top"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div data-mode="edit" hidden>
          <button class="button price-adjustments__button price-adjustments__button--cancel" type="button"
              data-action="cancel" title="${cancelLabel}"  data-toggle="tooltip"  data-placement="top"
            >
              <i class="fas fa-undo"></i>
            </button>

          <button class="button price-adjustments__button price-adjustments__button--save" type="button"
            data-action="save" title="${saveLabel}"  data-toggle="tooltip"  data-placement="top"
          >
            <i class="fas fa-save"></i>
          </button>
        </div>
      </td>
      <td><div class="loader__wrapper"><div class="js-loader js-loader loader"></div></div></td>
    </tr>
  `;
}

module.exports = {
  onLoad: onLoad
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-price-adjustment/booking-price-adjustment.js